import { ref } from 'vue'
import type { ConditionType, IConditionsConfig } from '../types'
import { isNil } from 'lodash-es'
export default (resetPagination: any, conditions?: IConditionsConfig[], useEasyConditions?: boolean) => {
  const _atomMap = new Map<string, ConditionType>()
  const _transMap = new Map<string, boolean>()
  const _conditions = ref(new Map<string, any>())
  conditions?.forEach(item => {
    item.atom && _atomMap.set(item.dataIndex, item.atom)
    typeof item.default !== 'undefined' && _conditions.value.set(item.dataIndex, item.default)
    _transMap.set(item.dataIndex, item.trans ?? true)
  })
  const handleConditionChange = (data: Record<string, any>) => {
    for (const key in data) {
      const item = data[key]
      if (item !== undefined) {
        _conditions.value.set(key, item)
      } else {
        _conditions.value.has(key) && _conditions.value.delete(key)
      }
    }
    resetPagination()
  }
  const _validateConditionValue = (key: string, value: any) => {
    const _atom = _atomMap.get(key)
    //! todo：优化between转成<  >
    if (_atom === 'between') {
      //! todo 检验两个大小
      return !(isNil(value[0]) && isNil(value[1]))
    }
    if (_atom === 'in') {
      return !!value.length
    }
    if (_atom === 'equal' || _atom === 'like') {
      return value === false || value === 0 || !!value
    }
    if (_atom === 'belong') {
      return !!value.length
    }
    return true
  }
  const getConditionValueAndType = (atom: ConditionType, value: any) => {
    let _atom = atom
    let _value = value
    if (atom === 'between') {
      _value = value.join(',')
      if (!isNil(value[0]) && isNil(value[1])) {
        _value = value[0]
        _atom = 'gt'
      }
      if (isNil(value[0]) && !isNil(value[1])) {
        _value = value[1]
        _atom = 'lt'
      }
    }
    if (atom === 'in') {
      _value = value.join(',')
    }
    return {
      conditionValue: _value,
      conditionType: _atom
    }
  }
  // const _formatConditionValue
  //! todo:优化trans传值
  const getConditions = () => {
    if (useEasyConditions) {
      const _res: Record<string, any> = {}
      _conditions.value.forEach((value, key) => {
        _res[key] = value
      })
      return _res
    }
    const _res: BasicPageReq['conditions'] | Record<string, any> = []
    _conditions.value.forEach((value, key) => {
      if (_validateConditionValue(key, value)) {
        if (_transMap.get(key)) {
          _res.push({
            conditionKeyName: key,
            conditionLinkType: 'and',
            ...getConditionValueAndType(_atomMap.get(key)!, value)
          })
        } else {
          _res.push({ [key]: value })
        }
      }
    })
    return _res
  }
  return {
    handleConditionChange,
    getConditions
  }
}
